import { Registry } from '@lightningjs/sdk'

import { backgroundDark, getColor, grey400 } from '../../constants/colors'
import { PLAYER_CONTROLS_SIGNALS } from '../../constants/signals'
import { AppConfig } from '../../services/appConfig'
import { TvRowsContainerModelItem } from '../../types/flo-experience'
import { getText } from '../../utils/dictionary'
import { HorizontalPointerWidth } from '../NavigationPointers/NavigationPointers'
import SpeechComp from '../speechComp/speechComp'
import UpNextCarousel from './upNextCarousel'

const DEFAULT_CAROUSELS_OFFSET = 0
const DEFAULT_UPNEXT_TIMER = 5
const SCREEN_WIDTH = 1920

export default class UpNext extends SpeechComp {
  private _playlist: TvRowsContainerModelItem
  private _updateTimerId = -1
  private _timeLeft = DEFAULT_UPNEXT_TIMER
  private readonly _onKeyPressBind = this.onKeyPress.bind(this)

  static _template() {
    return {
      w: SCREEN_WIDTH,
      h: 1080,
      color: backgroundDark,
      rect: true,
      CurrentContent: {
        x: 176,
        y: 140,
        alpha: 0.75,
        flex: { direction: 'column' },
        UpNextTimerText: {
          text: {
            text: '',
            fontSize: 35,
            advancedRenderer: true,
            textColor: getColor(grey400),
          },
        },
        UpNextCarousel: {
          type: UpNextCarousel,
          withSpotlight: false,
          offset: DEFAULT_CAROUSELS_OFFSET,
        },
      },
    }
  }

  set playlist(v) {
    this._playlist = v
  }

  get upNextTimerText() {
    return this.tag('UpNextTimerText')
  }

  get sectionText(): string {
    return 'Up Next'
  }

  get currentContent() {
    return this.tag('CurrentContent')
  }

  get upNextCarousel() {
    return this.tag('UpNextCarousel') as UpNextCarousel
  }

  async _enable() {
    document.addEventListener('keydown', this._onKeyPressBind)
    this.upNextCarousel.data = [this._playlist]
    this.upNextCarousel.title = getText('playerCarouselVodTitle')

    this._updateTimerId = Registry.setInterval(() => {
      if (this._timeLeft === 0) {
        this.signal(PLAYER_CONTROLS_SIGNALS.jumpNext)
      }
      this.updateCounter()
    }, 1000)

    this.checkNavigationPointersVisibility(true)
    this.speak()
  }

  _disable() {
    document.removeEventListener('keydown', this._onKeyPressBind)
    Registry.clearInterval(this._updateTimerId)
    this.checkNavigationPointersVisibility(false)
  }

  _getFocused() {
    return this.upNextCarousel
  }

  restartTimer() {
    this._timeLeft = DEFAULT_UPNEXT_TIMER
    this.updateCounter()
  }

  updateCounter() {
    this.upNextTimerText.patch({
      text: getText('playerUpNextCountdown').replace('{{timeLeft}}', this._timeLeft),
    })
    this._timeLeft--
  }

  onKeyPress() {
    this.upNextTimerText.patch({ alpha: 0 })
    Registry.clearInterval(this._updateTimerId)
  }

  $updateFocusByHover() {
    this.upNextTimerText.patch({ alpha: 0 })
    Registry.clearInterval(this._updateTimerId)
  }

  checkNavigationPointersVisibility(shouldShow) {
    const { isCursorVisible } = AppConfig.shared.appSettings
    const carousel = this.upNextCarousel?.carouselsContainer?.childList?.getAt(0)

    if (carousel?.navigationPointers) {
      // Specific position overrides for this carousel on the player, as it's not aligned with the rest of the screens
      carousel.navigationPointers.w = SCREEN_WIDTH - this.currentContent.x
      carousel.navigationPointers.leftContainer.x =
        HorizontalPointerWidth.RIGHT - HorizontalPointerWidth.LEFT - this.currentContent.x

      carousel.navigationPointers.visible = shouldShow && isCursorVisible
      carousel.checkNavigationPointersVisibility()
    }
  }
}
